import * as Yup from "yup";

export const newRoleFormValidation = Yup.object().shape({
  newRoleName: Yup.string().required("Role Name is required."),
  newRoleColor: Yup.string().required("Role Color is required.")
});
